import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type ProductsQueryVariables = Types.Exact<{ [key: string]: never }>

export type ProductsQuery = {
  __typename?: 'Query'
  products: {
    __typename?: 'ProductsCollection'
    items: Array<{ __typename?: 'Product'; name: string }>
  }
}

export const ProductsDocument = gql`
  query Products {
    products(filters: {}) {
      items {
        name
      }
    }
  }
`
export function useProductsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<ProductsQuery, ProductsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options)
}
export function useProductsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<ProductsQuery, ProductsQueryVariables>(
    ProductsDocument,
    options
  )
}
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>
export type ProductsQueryResult = ApolloReactCommon.QueryResult<
  ProductsQuery,
  ProductsQueryVariables
>
export function refetchProductsQuery(variables?: ProductsQueryVariables) {
  return { query: ProductsDocument, variables: variables }
}
